// extracted by mini-css-extract-plugin
module.exports = {"btn":"LoginButton_btn__3SLvd"};